import React, {useCallback, useEffect, useMemo, useState} from "react";
import {shallowEqual, useSelector} from "react-redux";
import { COLORWAY_TAB_CONFIG } from "../../../../../core/constants/color";

const TabGroup = ({
                    defaultTabIndex = 0,
                    callback,
                    firstTabName,
                    secondTabName,
                    thirdTabName,
                    executeInitialCallback,
                    colorTarget
                  }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(defaultTabIndex);
  const [isTabHidden, setIsTabHidden] = useState(false);

  const {configData} = useSelector(state => ({
    configData: state.optionWindow.CONFIG_DATA,
  }), shallowEqual);

  const handleSelectTab = useCallback((tabIndex) => {
    setActiveTabIndex(tabIndex);
    callback(tabIndex);
  }, [callback]);

  const {showSecondTab, showThirdTab} = useMemo(() => {
    if (colorTarget.startsWith("INTERIOR_")) {
      const colorway = configData["COLORWAY"];
      const config = COLORWAY_TAB_CONFIG[colorway];

      if (!config) {
        return {showSecondTab: false, showThirdTab: false};
      }

      return {
        showSecondTab: config.tabCount >= 2,
        showThirdTab: config.tabCount >= 3
      };
    }

    return {
      showSecondTab: !!secondTabName,
      showThirdTab: !!thirdTabName
    };
  }, [colorTarget, configData, secondTabName, thirdTabName]);

  useEffect(() => {
    if (executeInitialCallback) {
      handleSelectTab(defaultTabIndex);
    }
  }, [executeInitialCallback, defaultTabIndex]);

  useEffect(() => {
    if (colorTarget.startsWith("INTERIOR_")) {
      if (configData["COLORWAY"] === "SINGLE_COLOR") {
        setIsTabHidden(true);
      } else {
        setIsTabHidden(false);
      }
    } else if (colorTarget.startsWith("EXTERIOR_")) {
      if (!configData["EXT_SPECIAL"]) {
        setIsTabHidden(true);
      } else {
        setIsTabHidden(false);
      }
    }
  }, [configData]);

  return (
    <>
      {isTabHidden ? null : (
        <div className="tab-group">
          <div className="tab-container">
            <div
              className={`tab-item ${activeTabIndex === 0 ? 'active' : ''}`}
              onClick={() => {handleSelectTab(0)}}
            >
              {firstTabName}
            </div>

            <div
              className={`tab-item ${activeTabIndex === 1 ? 'active' : ''}`}
              onClick={() => {handleSelectTab(1)}}
              data-visible={showSecondTab}
            >
              {secondTabName}
            </div>

            <div
              className={`tab-item ${activeTabIndex === 2 ? 'active' : ''}`}
              onClick={() => {handleSelectTab(2)}}
              data-visible={showThirdTab}
            >
              {thirdTabName}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TabGroup;
